module.exports = __webpack_public_path__ + "img/man.605030ba.svg";